import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { ChallengeTimeInAppsSummaryEntity } from '../../entities/app-summary/challenge-time-in-apps-summary.entity';
import { MetricValueType } from '../../../../interface/dtos';

export interface ChallengeTimeInAppsAggregateRootProps {
  before: ChallengeTimeInAppsSummaryEntity;
  after: ChallengeTimeInAppsSummaryEntity;
}

export class ChallengeTimeInAppsAggregateRoot extends Entity<ChallengeTimeInAppsAggregateRootProps> {
  protected _id: string;
  static create(
    props: ChallengeTimeInAppsAggregateRootProps,
    entityId?: string
  ): ChallengeTimeInAppsAggregateRoot {
    const id = entityId || v4();
    const entity = new ChallengeTimeInAppsAggregateRoot({
      id,
      props,
    });
    return entity;
  }
  public validate(): void {}
  get type(): MetricValueType {
    return this.props.after.type;
  }
  get metricType() {
    return this.props.after.metricType;
  }
  get beforeValue() {
    return this.props.before.value;
  }
  get beforeCount() {
    return this.props.before.count;
  }
  get value() {
    return this.props.after.value;
  }
  get count() {
    return this.props.after.count;
  }
  get deviation() {
    return this.value - this.beforeValue;
  }
  get deviationPercentage() {
    return this.deviation !== 0 && this.beforeValue !== 0
      ? 100 * (this.deviation / this.beforeValue)
      : 0;
  }
  get beforeAverage() {
    return this.beforeCount !== 0
      ? this.beforeValue / this.beforeCount
      : this.beforeValue;
  }
  get average() {
    return this.count !== 0 ? this.value / this.count : this.value;
  }
  get averageDeviation() {
    return this.average - this.beforeAverage;
  }
  get averageDeviationPercentage() {
    return this.averageDeviation !== 0 && this.beforeAverage !== 0
      ? 100 * (this.averageDeviation / this.beforeAverage)
      : 0;
  }

  get afterUniqueUsersCount(): number {
    return this.props.after.uniqueUsers;
  }

  get beforeUniqueUsersCount(): number {
    return this.props.before.uniqueUsers;
  }
}
